/// <reference path="../../../../Scripts/typings/jquery/jquery.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/home/viewmodels/container',["require", "exports", "durandal/app", "common/viewmodelbase", "services/settings", "common/string"], function (require, exports, App, ViewModel, Configuration, StringExtensions) {
    "use strict";
    var ContainerViewModel = (function (_super) {
        __extends(ContainerViewModel, _super);
        //#region ctor
        function ContainerViewModel() {
            _super.call(this);
            //#endregion
            this.uri = "";
            this.showHost = false;
            this.isloading = true;
            this.title = $.t("app:modules.home.headline_title", { ifMissing: "home" });
            ko.track(this, ["uri", "showHost", "isloading"]);
        }
        ContainerViewModel.prototype.onActivated = function (context) {
            return Q(true);
        };
        ContainerViewModel.prototype.attached = function () {
            var _this = this;
            App.trigger("pushCurrentNode", function (node) { return _this.embed(node); });
            // resizing
            this.showHost = true;
        };
        ContainerViewModel.prototype.onBeforeClosing = function (path) {
            if (!close)
                return;
            this.showHost = false;
            return true;
        };
        ContainerViewModel.prototype.embed = function (item) {
            var that = this;
            var link = this.buildLink(item);
            // remap
            var url = link.indexOf("https") >= 0
                ? link
                : Configuration.Settings.getHost() + link;
            //
            this.isloading = true;
            jQuery("#slhost").load(function () {
                that.isloading = false;
            });
            //pdfs machen Ärger...
            window.setTimeout(function () { return that.isloading = false; }, 1500);
            this.uri = url;
        };
        ContainerViewModel.prototype.buildLink = function (item) {
            var link = "";
            if (item.type === "ApplicationLink" && item.raw.data.route != null) {
                link = item.parent.application.appendUrl(item.raw.data.route);
            }
            else {
                var app = item.type === "Application"
                    ? item.application
                    : item.parent.application;
                link = app.link;
            }
            var externalParameters = this.getExternalParameters();
            if (externalParameters !== "" && link.indexOf("?") < 0) {
                externalParameters = "?" + externalParameters;
                externalParameters = externalParameters.replace("?&", "?");
            }
            var url = link + externalParameters;
            return url;
        };
        ContainerViewModel.prototype.getExternalParameters = function () {
            var search = window.location.search;
            var result = "";
            if (search !== null && search !== "") {
                search = search.replace("?", "&");
                var parameters = search.split("&");
                parameters.forEach(function (x) {
                    if (x !== "" &&
                        !StringExtensions.contains(x, "nid") &&
                        !StringExtensions.contains(x, "token") &&
                        !StringExtensions.contains(x, "ext") &&
                        !StringExtensions.contains(x, "actas")) {
                        result += "&" + x;
                    }
                });
            }
            return result;
        };
        return ContainerViewModel;
    }(ViewModel.ViewModelBase));
    return ContainerViewModel;
});

